import {
  GET_SUPPLIERS,
  GET_SUPPLIER_BY_ID,
  REGISTER_SUPPLIER,
  SET_SUPPLIER_TO_NULL,
} from "./types";

const initialState = {
  suppliers: [],
  supplierToEdit: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SUPPLIERS:
      return {
        ...state,
        suppliers: action.payload,
      };
    case GET_SUPPLIER_BY_ID:
      return {
        ...state,
        supplierToEdit: action.payload,
      };
    case SET_SUPPLIER_TO_NULL:
      return {
        ...state,
        supplierToEdit: null,
      };

    default:
      return state;
  }
};
